'use client'

/**
 * Thin storefront wrapper around PopupHost that wires the analytics onEvent
 * callback. Lives in the storefront (not shared-ui) to keep the dependency
 * direction clean: shared-ui has no analytics import; the storefront glues them.
 */

import { PopupHost, type PopupItem } from '@sifly/shared-ui/popups'
import { track } from '@/lib/analytics'

export function AnalyticsPopupHost({ items }: { items: PopupItem[] }) {
  return (
    <PopupHost
      items={items}
      onEvent={(type, meta) => track(type, meta ?? {})}
    />
  )
}
